// src/pages/Settings.jsx — v8.9
// ТЗ: Вариант B — честный stub
// "Settings are not available in this version."

export default function Settings() {
  return (
    <div style={{
      display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center",
      minHeight: 360, gap: 16, textAlign: "center",
    }}>
      <div style={{ fontSize: 32, opacity: 0.3 }}>⊙</div>
      <div style={{
        fontFamily: "var(--font-mono)", fontSize: 13, fontWeight: 700,
        letterSpacing: "0.06em", color: "var(--text-secondary)",
        textTransform: "uppercase",
      }}>
        Settings
      </div>
      <div style={{
        fontFamily: "var(--font-mono)", fontSize: 11,
        color: "var(--text-muted)", maxWidth: 320, lineHeight: 1.7,
      }}>
        Settings are not available in this version.
        <br />
        Engine configuration is managed automatically.
      </div>
      <div style={{
        marginTop: 8,
        padding: "6px 14px", borderRadius: "var(--radius)",
        background: "var(--bg-elevated)", border: "1px solid var(--border-subtle)",
        fontFamily: "var(--font-mono)", fontSize: 9, letterSpacing: "0.1em",
        color: "var(--text-muted)", textTransform: "uppercase",
      }}>
        v8.9 · PROTECTION-FIRST
      </div>
    </div>
  );
}
